module.exports = __webpack_public_path__ + "img/header-img.94bd6dc4.png";